import React from 'react';

const Certifications = ({ userProfile }) => {
  const { certifications } = userProfile;
  return <div>{certifications.filter(certification => certification).join(', ')}</div>;
};

export default Certifications;
